import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import schema from "async-validator";
import dialog from "./utils/dialog";
import cookie from "@/utils/store/cookie";
import $ from 'jquery';

import './assets/styles/common.css'
import './assets/styles/style.css'
import './assets/styles/home_header.css'
import '@/assets/styles/home.css';
import './assets/plugins/perfect-scrollbar.min.css'
import './assets/plugins/js/qtip/jquery.qtip.min.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './element-invisibles.scss'
import {
  parseQuery
} from "@/utils";

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function (rule) {
  return new schema(rule);
};
Vue.prototype.$dialog = dialog;
Vue.prototype.$cookie = cookie;

const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}


var urlSpread = parseQuery()["spread"];

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
